/**
 * WebMCP declarative API attributes (Chrome proposal).
 * Spread these onto a <form> or an input so browser agents can discover it.
 * Kept as plain attribute objects so no React type augmentation is needed.
 */
export const toolForm = (name: string, description: string): Record<string, string> => ({
  toolname: name,
  tooldescription: description,
});

export const toolParam = (description: string): Record<string, string> => ({
  toolparamdescription: description,
});
